import React from "react"

import FTPServer from "../../../../components/Products/IN-LAN/Videos/video-in-lan-500"

import SEOHelmet from '../../../../components/Layout/SEOHelmet'
import Footer from "../../../../components/Layout/footer"

const seodata = {
  title: 'IN-LAN 500 Powerline Adapter',
  description: 'IN-LAN is an intelligent and secure technology that lets you set up a home network easily via your household power grid - without the need of complex and expensive dedicated cabling.',
  image: '/images/Search/P_SearchThumb_Powerline.png'
}

export default (props) => (
  <React.Fragment>
    <SEOHelmet title={seodata.title} description={seodata.description} image={seodata.image} location={props.location.pathname} />
    <h1 id="introduction" style={{ marginTop: 0 }}>
      IN-LAN 500 Powerline Adapter
    </h1>
    <FTPServer />
    <br />
    <br />
    <Footer
      previousTitle="Products"
      previousLink="/fr/Products/"
      nextTitle="IN-LAN"
      nextLink="/fr/Products/IN-LAN/" />
  </React.Fragment>
)